import React from "react";
import PropTypes from "prop-types";
import { Outlet, useLocation } from "react-router-dom";
import SetupFlowHeader from "./setup-flow-header";
import UserIdsDisplayContainer from "../containers/user-ids-display-container";
import { SQUARE_USER_PROP_TYPES, UNKNOWN_USER } from "../constants/proptypes";
import ConflictingStoreModalContainer from "../containers/conflicting-store-modal-container";
import useZendeskWidget from "../hooks/use-zendesk-widget";

const SetupLayout = ({
  squareUser = UNKNOWN_USER,
  disconnect,
  disconnecting = false,
  withinPaymentReadUpdateFlow,
  zendeskWidgetEnabled,
}) => {
  const routerLocation = useLocation();

  useZendeskWidget({
    location: routerLocation,
    squareUser,
    hide: routerLocation.pathname === "/",
    zendeskWidgetEnabled,
  });

  return (
    <div className="setup-container" data-testid="setup-layout">
      <SetupFlowHeader
        squareUser={squareUser}
        disconnect={disconnect}
        disconnecting={disconnecting}
        withinPaymentReadUpdateFlow={withinPaymentReadUpdateFlow}
        pathname={routerLocation.pathname}
      />
      <main className="login-to-mailchimp">
        <div className="login-to-mailchimp-content">
          <Outlet />
          <ConflictingStoreModalContainer />
        </div>
        <UserIdsDisplayContainer />
      </main>
    </div>
  );
};

SetupLayout.propTypes = {
  squareUser: SQUARE_USER_PROP_TYPES,
  disconnecting: PropTypes.bool,
  disconnect: PropTypes.func.isRequired,
  withinPaymentReadUpdateFlow: PropTypes.bool.isRequired,
  zendeskWidgetEnabled: PropTypes.bool.isRequired,
};

export default SetupLayout;
